import { Logs } from "@src/core/services";
import { Back, Container, ContentContainer, PageTitle } from "@src/core/styles";
import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Arrow } from "@src/core/icons/arrow.svg";
import { FormContainer } from "../route-management-page/components/form-component/form-components.styles";
import {
  TitleWrap,
  WorkspaceName,
} from "../route-management-page/components/form-component/components/method-form/method-form.styles";
import { logDate } from "@src/core/utils";
import { Inner, Wrapper, LogsWrapper, SectionTitle, MethodBadge, RouteInfoGrid, RouteInfoItem, RouteInfoLabel, RouteInfoValue } from "./log-page.styles";

export const LogPage: FC = () => {
  const { logId } = useParams();
  const navigate = useNavigate();

  const { data: log } = useQuery({
    queryKey: ["route", logId],
    queryFn: () =>
      Logs.getOne({
        logId: logId ?? "",
      }),
  });

  const backHandler = () => {
    navigate(-1);
  };

  const logData = log?.data;

  return (
    <Container>
      <ContentContainer>
        <FormContainer>
          <Back onClick={backHandler}>
            <Arrow />
          </Back>
          <TitleWrap>
            {log?.data && (
              <WorkspaceName>
                {logDate(log.data.time).date} {logDate(log.data.time).time}
              </WorkspaceName>
            )}
            <PageTitle>Log entry #{log?.data.id}</PageTitle>
          </TitleWrap>

          {logData?.route && (
            <RouteInfoGrid>
              {logData.route.method && (
                <RouteInfoItem>
                  <RouteInfoLabel>Метод</RouteInfoLabel>
                  <MethodBadge method={logData.route.method}>
                    {logData.route.method.toUpperCase()}
                  </MethodBadge>
                </RouteInfoItem>
              )}
              {logData.route.name && (
                <RouteInfoItem>
                  <RouteInfoLabel>Имя</RouteInfoLabel>
                  <RouteInfoValue>{logData.route.name}</RouteInfoValue>
                </RouteInfoItem>
              )}
              {logData.route.url && (
                <RouteInfoItem>
                  <RouteInfoLabel>URL</RouteInfoLabel>
                  <RouteInfoValue>{logData.route.url}</RouteInfoValue>
                </RouteInfoItem>
              )}
              {logData.route.http_code && (
                <RouteInfoItem>
                  <RouteInfoLabel>HTTP код</RouteInfoLabel>
                  <RouteInfoValue>{logData.route.http_code}</RouteInfoValue>
                </RouteInfoItem>
              )}
            </RouteInfoGrid>
          )}

          <LogsWrapper>
            {logData?.time && (
              <>
                <SectionTitle>Время запроса</SectionTitle>
                <Wrapper>{logData.time}</Wrapper>
              </>
            )}

            {logData?.headers && (
              <>
                <SectionTitle>Заголовки</SectionTitle>
                <Wrapper>
                  {Object.entries(logData.headers).map(([headerName, values]) => (
                    <Inner key={headerName}>
                      <strong>{headerName}:</strong>{" "}
                      {Array.isArray(values) ? values.join(", ") : String(values)}
                    </Inner>
                  ))}
                </Wrapper>
              </>
            )}

            {logData?.route?.response_body && (
              <>
                <SectionTitle>Тело ответа</SectionTitle>
                <Wrapper>
                  <Inner>{logData.route.response_body}</Inner>
                </Wrapper>
              </>
            )}
          </LogsWrapper>
        </FormContainer>
      </ContentContainer>
    </Container>
  );
};
